import { createContext, useContext, useState, useCallback } from "react";
import ru from "@/i18n/ru.json";
import en from "@/i18n/en.json";
import kk from "@/i18n/kk.json";

const DICTS = { ru, en, kk };
export const LANGS = [
  { code: "ru", label: "Рус" },
  { code: "en", label: "Eng" },
  { code: "kk", label: "Қаз" },
];

const I18nContext = createContext(null);

const resolve = (dict, key) => key.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("nutriscan_lang") || "ru");

  const setLang = useCallback((code) => {
    localStorage.setItem("nutriscan_lang", code);
    setLangState(code);
  }, []);

  const t = useCallback((key) => {
    const val = resolve(DICTS[lang], key);
    if (val != null) return val;
    const fallback = resolve(DICTS.ru, key);
    return fallback != null ? fallback : key;
  }, [lang]);

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
